// @ts-nocheck
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client/react";
import { BrowserRouter } from "react-router-dom";
import "./matcha-theme.css";
import App from "App";
import { AuthProvider } from "auth";
import { SubscriptionAccessProvider } from "subscription";
import { apolloClient } from "./apollo/client";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <SubscriptionAccessProvider>
          <SoftUIControllerProvider>
            <App />
          </SoftUIControllerProvider>
        </SubscriptionAccessProvider>
      </AuthProvider>
    </ApolloProvider>
  </BrowserRouter>
);
